import { httpsCallable } from 'firebase/functions';
import { functions } from '@/services/firebaseFunctions';

export type SyncShippingTrackerFrom17TrackParams = {
  trackingNumber: string;
  carrierId?: string;
  force?: boolean;
};

export type ShippingTrackerUpdateFrom17Track = {
  formatted?: string;
  components: {
    trackingNumber: string;
    carrierId: string;
    deliveryDateMs?: number;
    currentStatus?: string;
    trackingHistory?: Array<{
      timestampMs: number;
      status: string;
      location?: string;
      details?: string;
    }>;
    origin?: string;
    destination?: string;
    additionalDetails?: Record<string, unknown>;
  };
  meta?: Record<string, unknown>;
};

export async function callSyncShippingTrackerFrom17Track(
  params: SyncShippingTrackerFrom17TrackParams
): Promise<ShippingTrackerUpdateFrom17Track> {
  const fn = httpsCallable(functions, 'syncShippingTrackerFrom17Track');
  const res = await fn(params);
  return res.data as ShippingTrackerUpdateFrom17Track;
}

